import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=74b318be&scoped=true&"
import script from "./AccountInfo.vue?vue&type=script&lang=ts&"
export * from "./AccountInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b318be",
  null
  
)

export default component.exports